import axios from 'axios';
import { REST_HOSTNAME } from '../Config';

const axiosInstance = axios.create({
    baseURL: REST_HOSTNAME
});

// Add request interceptor
axiosInstance.interceptors.request.use(
    function (config) {
        const jwt = localStorage.getItem('jwt');
        if (jwt) {
            config.headers['x-access-token'] = jwt; // Add JWT to the headers
        }
        return config;
    },
    function (error) {
        return Promise.reject(error);
    }
);

export interface IComment {
    id: number;
    hsk_level: number | null;
    good_comment: string | null;
    bad_comment: string | null;
    bug_report: string | null;
}

export interface ISentenceScoreComment {
    id: number;
    bug_report: string;
    bug_category: string;
    sentence_score_id: number;
    sentence_score_bug_flag_list: boolean[];
    class_name?: string;
}

export interface ITeacherAudioComment {
    id: number;
    bug_report: string;
    bug_category: string;
    sentence_audio_id: number | null;
    sentence_id: number | null;
    text_to_speech_speaker_id: string | null;
    is_slow_audio: boolean | null;
    dialog_prompt_id: number | null;
    audio_text: string | null;
    audio_role: string | null;
    class_name?: string;
}

export const CommentApi = {
    getAll: function () {
        return axiosInstance.request<IComment[]>({
            method: "GET",
            url: `/comment`
        });
    },
    getById: function (commentId: number) {
        return axiosInstance.request<IComment>({
            method: "GET",
            url: `/comment/${commentId}`
        });
    },
    create: function (comment: IComment) {
        return axiosInstance.request<IComment>({
            method: "POST",
            url: `/comment`,
            data: comment
        });
    },
    update: function (comment: IComment) {
        return axiosInstance.request<string>({
            method: "PUT",
            url: `/comment`,
            data: comment
        });
    },
    delete: function (commentId: number) {
        return axiosInstance.request<string>({
            method: "DELETE",
            url: `/comment/${commentId}`,
        });
    },
    createSentenceScoreComment: function (comment: ISentenceScoreComment) {
        return axiosInstance.request<ISentenceScoreComment>({
            method: "POST",
            url: `/sentence_score_comment`,
            data: comment
        });
    },
    getAllTeacherAudioComments: function () {
        return axiosInstance.request<ITeacherAudioComment[]>({
            method: "GET",
            url: `/teacher_audio_comment`
        });
    },
    getTeacherAudioCommentById: function (commentId: number) {
        return axiosInstance.request<ITeacherAudioComment>({
            method: "GET",
            url: `/teacher_audio_comment/${commentId}`
        });
    },
    createTeacherAudioComment: function (comment: ITeacherAudioComment) {
        return axiosInstance.request<ITeacherAudioComment>({
            method: "POST",
            url: `/teacher_audio_comment`,
            data: comment
        });
    },
    updateTeacherAudioComment: function (comment: ITeacherAudioComment) {
        return axiosInstance.request<string>({
            method: "PUT",
            url: `/teacher_audio_comment`,
            data: comment
        });
    },
    deleteTeacherAudioComment: function (commentId: number) {
        return axiosInstance.request<string>({
            method: "DELETE",
            url: `/teacher_audio_comment/${commentId}`,
        });
    },
}
